import { useRef, useState } from 'react'

import { ISessionNavigation, ISessionUseNavigationState } from '../types'

const useNavigationState: ISessionUseNavigationState = () => {
  const [navigationLoading, setNavigationLoading] = useState<boolean>(false)
  const navigationRef = useRef<ISessionNavigation>(null)
  const onNavigationLoadingRef = useRef<(loading: boolean) => void>(null)
  if (null === onNavigationLoadingRef.current) {
    onNavigationLoadingRef.current = (loading: boolean) => {
      setNavigationLoading(loading)
    }
  }

  return { navigationRef, navigationLoading, onNavigationLoadingRef } as const
}

export default useNavigationState
